export default "__VITE_ASSET__tGZzAv97__"